import axios from "axios";

const getBundle = async (context) => {
    try {
        context.commit('clearError')
        context.commit('setLoading', true)
        await context.dispatch('setBundle', context.getters['bundle_id'])
        context.commit('setLoading', false)
    } catch(e){
        context.commit('setLoading', false)
        context.commit('setError', e.message)
    }
}
const selectBundleItem = async (context, payload) => {
    try {
        context.commit('clearError')
        context.commit('setLoading', true)
        // запоминаем в сессии выбранный элемент и обновляем данные this.state.bundle
        let params = new URLSearchParams();
        params.append('action', 'selectBundleItem');
        params.append('key', payload.session_key);
        params.append('id', payload.id);
        params.append('option_id', payload.option_id)
        await axios.put('/rest/product', params)

        await context.dispatch('setBundle', context.getters['bundle_id'])
        context.commit('setLoading', false)
    } catch(e){
        context.commit('setLoading', false)
        context.commit('setError', e.message)
    }
}

const setBundle = async ({commit}, bundle_id) => {
    let params = new URLSearchParams();
    params.append('action', 'getBundle');
    params.append('product_id', bundle_id);
    await axios.get('/rest/product', {params}).then((response) => {
        commit('SET_BUNDLE', response.data.bundle)
        commit('SET_SELECTED_BUNDLE_ITEMS', response.data.selected_items)
        commit('SET_SELECTED_BUNDLE_ITEMS_SUMM', response.data.set_summs)
    }).catch((error) => {
        console.log('error', error);
    })
}

export default {
    getBundle,
    selectBundleItem,
    setBundle
}
